/**
 * https://www.sanity.io/docs/apis-and-sdks/image-urls#bhpyf4m0
 * @param url
 * @param preset
 */
export function useSanityImage(
	url?: string,
	preset: 'cover' | 'thumbnail' | 'hero' | 'highRes' = 'cover'
): string | undefined {
	const presets = {
		cover: '?fit=max&w=1200&fm=webp',
		hero: '?fit=max&w=800&fm=webp',
		thumbnail: '?fit=max&w=600&fm=webp',
		highRes: '?fit=max&w=2000&fm=webp'
	};

	if (!url) return undefined;
	return url + presets[preset];
}
